var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "./IconContainer";
const EditPencilIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({ className: classNames("gerudo-icon-edit-pencil", size, className) }, props),
        React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": title },
            React.createElement("title", null, title),
            React.createElement("path", { d: "M7.14945 17.6741L6.47352 18.3411H1.68359V13.5472L2.35118 12.8802M7.14945 17.6741C6.74357 16.5763 6.10451 15.5793 5.27621 14.7518C4.4479 13.9242 3.45001 13.2857 2.35118 12.8802M7.14945 17.6741L15.9282 8.88671M2.35118 12.8802L11.3219 3.9094C13.4557 4.89458 15.112 6.68426 15.9282 8.88671M15.9282 8.88671L17.8141 7.0025C18.1129 6.69443 18.2985 6.29447 18.3409 5.86763C18.3834 5.44079 18.28 5.01216 18.0478 4.65141C17.3568 3.58038 16.4432 2.67048 15.3691 1.98351C15.0095 1.74698 14.5795 1.64109 14.1511 1.68359C13.7226 1.72609 13.3219 1.91439 13.0158 2.21695L11.3052 3.88439C12.3673 4.37331 13.3223 5.06685 14.1156 5.92524C14.909 6.78364 15.5249 7.79003 15.9282 8.88671Z", stroke: "currentColor", strokeWidth: "1.67", strokeLinecap: "round", strokeLinejoin: "round" }))));
};
EditPencilIcon.defaultProps = {
    title: "EditPencilIcon",
};
export { EditPencilIcon };
export default EditPencilIcon;
//# sourceMappingURL=EditPencil.js.map